import { desktopQuery, mobileQuery, tabletQuery } from '@globals/themes/themeConstants'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useEffect, useRef, useState } from 'react'

const useIsVisible = () => {
  const ref = useRef<HTMLElement>()
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const isTablet = useMediaQuery(tabletQuery)
  const isMobile = useMediaQuery(mobileQuery)
  const isDesktop = useMediaQuery(desktopQuery)
  useEffect(() => {
    if (ref.current) {
      const element = ref.current
      setIsVisible(element.checkVisibility())
    }
  }, [isTablet, isMobile, isDesktop])

  return {
    ref,
    isVisible,
  }
}

export default useIsVisible
